import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const autoReplenishEmbeddedSelector = createSelector(testTargetOffersSelector, offers => offers.autoReplenishEmbedded || Empty.Object);

export { autoReplenishEmbeddedSelector };
